import * as React from "react";
import { withTranslation } from "react-i18next";
import { StyledModal } from "./StyledModal";
import { DataService } from "../../services/DataService";
import i18n from "../../i18n";
import {
  InvalidRowColors,
  Period,
  ProjectInvoice,
  ProjectInvoiceKeys,
} from "../../pages/KickbackProjectReportPage";
import EditableTable, { GroupedCol } from "../EditableTable";
import { ColumnDef } from "@tanstack/react-table";
import { OverlayInjectedProps } from "react-bootstrap/esm/OverlayTrigger";
import {
  Button,
  Form,
  OverlayTrigger,
  Spinner,
  Stack,
  Tooltip,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamation, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Typeahead } from "react-bootstrap-typeahead";
import { _helpers, generateRgb } from "../../lib/ProjectReportValidation";
import { Invoice } from "../../services/API/Invoices";
interface ProjectInvoiceGrouped extends ProjectInvoice {
  items:ProjectInvoice[]
}
interface IKickbackreportDuplicatesProps {
  closeModal: () => void;
  period: string;
  report: ProjectInvoice[];
  invalidColors: InvalidRowColors;
  handleSubmitModal: (verifiedData?:ProjectInvoice[],deletedRows?:number[]) => void;
  customerDict:any;
  contractDict:any;
  //deepClone: (data:any) => any;
  //getMinOrMaxDateRange:(key: string,period:string|null) => string;
  validateSum :(sumToValidate: string) => [boolean, string];
  csrd:boolean;
  editableColumns:ColumnDef<ProjectInvoice>[];
  groupedColumns: GroupedCol<ProjectInvoice>[];
  findDbDuplicates: (data:ProjectInvoice[]) => void;

  //columns:ColumnDef<ProjectInvoice>[]
  //_cell:(props:any,key:ProjectInvoiceKeys) => JSX.Element | undefined;
  //onChangeContractUsers:(uniqueRowId: number, val: any, key: any, index?: number) => Promise<void>;
  //showValidationInfo:(props:OverlayInjectedProps,key:ProjectInvoiceKeys) => JSX.Element;
}

interface IKickbackreportDuplicatesState {
  invoices: ProjectInvoice[];
  loading: boolean;
  width: number;
  keyedInvoices:any,
  deletedRows:number[];
  collapsedGroups:number[]; 
  //report:ProjectInvoice[];
}
class KickbackReportDuplicatesModal extends React.Component<
  IKickbackreportDuplicatesProps,
  IKickbackreportDuplicatesState
> {
  constructor(props: IKickbackreportDuplicatesProps) {
    super(props);
    this.state = {
      invoices: [],
      loading: true,
      width: window.innerWidth,
      keyedInvoices:{},
      deletedRows:[],
      collapsedGroups:[],
      //report:[]
    };
    
  }
  duplicateColumns: ColumnDef<ProjectInvoice>[] = [
    {
      id: "customerName",
      header: `${i18n.t("kickbackProject.customerName")}`,
      cell: (props) => this._cell(props, "customerName"),
      minSize: 125,
    },
    {
      id: "customerOrgId",
      header: `${i18n.t("kickbackProject.customerOrgId")}`,
      cell: (props) => this._cell(props, "customerOrgId"),
      minSize: 125,
    },
    {
      id: "contractId",
      header: `${i18n.t("kickbackProject.contractId")}`,
      cell: (props) => this._cell(props, "contractId"),
      minSize: 125,
    },
    {
      id: "totalExclMoms",
      header: `${i18n.t("kickbackProject.sum")}`,
      cell: (props) => this._cell(props, "totalExclMoms"),
      minSize: 100,
    },

    {
      id: "invoiceNumber",
      header: `${i18n.t("kickbackProject.invoiceNumber")}`,

      cell: (props) => this._cell(props, "invoiceNumber"),
      minSize: 125,
      //maxSize: 100,
    },
    {
      id: "billingDate",
      header: `${i18n.t('kickbackProject.billingDate')}` /*`${i18n.t('kickbackProject.startDate')}`*/,
      cell: (props) => this._cell(props, "billingDate"),
      //maxSize: 40,
      minSize: 40,
    },
    {
      accessorKey: "none",
      header: () => i18n.t("invoiceReport.table.headers.tools"),
      cell: (props) => {
        return (
          <Stack
            direction="horizontal"
            style={{
              height: 40,
              justifyContent: "space-evenly",
            }}
          >
            <Button
              className="button outline-button-danger row-btn"
              onClick={(ev) => {
                this.handleRowDelete(props.row.original);
              }}
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </Stack>
        );
      },
    },
  ];
  async componentDidMount(): Promise<void> {
    //this.setState({report:this.props.report})
    const data = await DataService.Invoices.GetProjectReportData(
      this.props.period,
      i18n.language
    );
if(this.props.csrd && data.length > 0){
//console.log(data,this.props.report)
const keyedInvoices = this.keyInvoices(data)
const groupedAndSummedCsrdRows = Object.values(this.props.report.reduce((acc:{[key:string]:{originalGroup:any[]}},item) => {
    if(!acc[`${item.groupId}`]){
      acc[`${item.groupId}`] = {originalGroup:[]}
      acc[`${item.groupId}`].originalGroup.push(item)
      return acc
    }
    else{
      acc[`${item.groupId}`].originalGroup.push(item)
      return acc
    }
},{})).map(inv => {
  return inv.originalGroup.reduce((acc:{csrdGroup:any[],customerOrgId:string,contractId:string,invoiceNumber:string,billingDate:string,priceExcMoms:number},item) => {
      acc.customerOrgId = item.customerOrgId;
      acc.contractId = item.contractId;
      acc.invoiceNumber = acc.invoiceNumber || item.invoiceNumber || '';
      //acc.csrdGroup
      acc.billingDate = acc.billingDate || (item.billingDate ? item.billingDate.split('T')[0] : '');
      acc.priceExcMoms += parseFloat(item.rowSumExclMoms) || 0; 
      return acc;
  },{
    csrdGroup:inv.originalGroup,
    customerOrgId: '',
    contractId: '',
    invoiceNumber: '',
    billingDate: '',
    priceExcMoms: 0,
  })
}).reduce((acc:{[key:string]:any[]},item) => {
      acc[  `${item.customerOrgId}#${item.contractId}#${
        item.invoiceNumber
      }#${item.billingDate}#${item.priceExcMoms}`] = item.csrdGroup
      return acc
},{})
const res:ProjectInvoice[] = [];
Object.keys(groupedAndSummedCsrdRows).forEach(key => {
  if(keyedInvoices[key]){
   
    const dupColor = generateRgb();
    groupedAndSummedCsrdRows[key].forEach((x:ProjectInvoice) => res.push({...x,isDuplicate:{value:true,backgorundColor:dupColor}}))
  }
})
if(res.length > 0){
  this.props.findDbDuplicates(res)
  window.addEventListener("resize", this.handleResize);
this.setState({ invoices: res ,keyedInvoices}, () =>
this.setState({ loading: false })
);
}
else{
  this.props.handleSubmitModal()
}


}else{
  if(data.length > 0){
    const keyedInvoices: { [key: string]: string } = data.reduce(
      (keyedInvoices: { [key: string]: string }, item) => {
        const billing = item.billingDate.toString().split("T");
  
        if (
          !keyedInvoices[
            `${item.customerOrgId}${item.contractId}${
              item.invoiceNumber
            }${billing[0].replace(" ", "")}${item.priceExcMoms}`
          ]
        ) {
          keyedInvoices[
            `${item.customerOrgId}${item.contractId}${
              item.invoiceNumber
            }${billing[0].replace(" ", "")}${item.priceExcMoms}`
          ] = "unique";
        }
        return keyedInvoices;
      },
      {}
    );
    console.log(keyedInvoices)
   let counter = 1
    const duplicates: ProjectInvoice[] = this.props.report.reduce(
      (duplicates: ProjectInvoice[], item, curr) => {
        console.log(   
         item
        )
        if (
          keyedInvoices[
            `${item.customerOrgId}${item.contractId}${item.invoiceNumber}${item.billingDate}${item.totalExclMoms.value}`
          ] == "unique"
        ) {
          let dup = JSON.parse(JSON.stringify(item));
          dup.isDuplicate = {
            value: true,
            backgorundColor: this.props.invalidColors[counter],
          };
          duplicates.push(dup);
        }
        else{
          counter++
        }
        return duplicates;
      },
      []
    );
      if(duplicates.length > 0){
        window.addEventListener("resize", this.handleResize);
    this.setState({ invoices: duplicates ,keyedInvoices}, () =>
      this.setState({ loading: false })
    );
      }
      else{
        this.props.handleSubmitModal()
      }
  }
  else{
    this.props.handleSubmitModal()
  }
}

   
      
    
    
  }
  // componentDidUpdate(prevProps: Readonly<IKickbackreportDuplicatesProps>, prevState: Readonly<IKickbackreportDuplicatesState>, snapshot?: any): void {
  //   if (prevProps.report !== this.props.report) {
  //     this.setState({ report: this.props.report });
  //   }
  // }
  async componentWillUnmount(): Promise<void> {
    document.removeEventListener("resize", this.handleResize);
  }
  private handleResize = (): void => {
    this.setState({ width: window.innerWidth });
  };
  private keyInvoices = (data:Invoice[]): { [key: string]: string } => {
    const keyedInvoices: { [key: string]: string } = data.reduce(
      (keyedInvoices: { [key: string]: string }, item) => {
        const billing = item.billingDate.toString().split("T");
    
        if (
          !keyedInvoices[
            `${item.customerOrgId}#${item.contractId}#${
              item.invoiceNumber
            }#${billing[0].replace(" ", "")}#${item.priceExcMoms}`
          ]
        ) {
          keyedInvoices[
            `${item.customerOrgId}#${item.contractId}#${
              item.invoiceNumber
            }#${billing[0].replace(" ", "")}#${item.priceExcMoms}`
          ] = "unique";
        }
        return keyedInvoices;
      },
      {}
    );
    return keyedInvoices
  }
  private verifyChanges = ():void => {
    let duplicate = 0
     for (let index = 0; index < this.state.invoices.length; index++) {
      if (
        this.state.keyedInvoices[
          `${this.state.invoices[index].customerOrgId}${this.state.invoices[index].contractId}${this.state.invoices[index].invoiceNumber}${this.state.invoices[index].billingDate}${this.state.invoices[index].totalExclMoms.value}`
        ] == "unique"
      ){
        duplicate++
      }
      
     }
     if(duplicate == 0){
      this.props.handleSubmitModal(this.state.invoices,this.state.deletedRows)
     }
     
  }
  private handleRowDelete = (row: any): void => {

    const stateAsOffNow:ProjectInvoice[] = _helpers.deepClone(this.state.invoices)/*JSON.parse(JSON.stringify(this.state.invoices))*/
  const res =  stateAsOffNow
    .filter((x) => x.uniqueRowId !== row.uniqueRowId);
    
    this.setState(
      { invoices: res /*, invoicesParsed: invoices */ },
      () => this.setState(prevState => ({deletedRows:[...prevState.deletedRows,row.uniqueRowId]}))
    );
    // }
  };
  private onChangeDuplicates = (change:any,key:string,rowId:number): void => {
    const res = this.update(change,key,rowId)
    this.setState({invoices:res})
  }
  private update = (change:any,key:string,rowId:number): ProjectInvoice[] => {
    let stateAsOfNow:ProjectInvoice[] = _helpers.deepClone(this.state.invoices)
    for (let index = 0; index < stateAsOfNow.length; index++) {
      if(stateAsOfNow[index].uniqueRowId == rowId){
        switch (key){
          case 'totalExclMoms': {
           
            stateAsOfNow[index][key]['value'] = +change
            stateAsOfNow[index][key]['display'] = change
            stateAsOfNow[index][key]['valid'] = this.props.validateSum(change)[0]
            break;
          }
          case 'invoiceNumber':{
            stateAsOfNow[index][key] = change
            break;
          }
          case 'billingDate':{
            stateAsOfNow[index][key] = change
            break;
          }
          case 'contractId':{
            stateAsOfNow[index][key] = typeof change[0] == "undefined" ? '' : change[0]
            break;
          }
          
          case 'customerName':{
           stateAsOfNow[index]['customerName'] = typeof change[0] == 'undefined' ? '' : change[0]
           stateAsOfNow[index]['customerOrgId'] = typeof change[0] == 'undefined' ? '' : this.props.customerDict[change[0]]['customerOrgId']
            break;
          }
          case 'customerOrgId':{
            stateAsOfNow[index]['customerOrgId'] = typeof change[0] == 'undefined' ? '' : change[0]
            stateAsOfNow[index]['customerName'] = typeof change[0] == 'undefined' ? '' : Object.entries(this.props.customerDict).filter(([key,value]) => {
              const buff:any = value
              if(buff['customerOrgId'] == change[0]){
                return key
              }
            })[0][0]
            break;
          }
          
        }
      }
      
      
    }
    const result:ProjectInvoice[] = stateAsOfNow
    return result
  }
  private _cell = (
    props: any,
    key: ProjectInvoiceKeys
  ): JSX.Element | undefined => {
    const item = props.row.original;
    if (key == "totalExclMoms") {
      return (
        <div
          className={`fieldWrapper ${
            item.totalExclMoms.display.length == 0
              ? "fieldWrapper-error"
              : item.totalExclMoms.valid
              ? ""
              : "fieldWrapper-warn"
          }`}
          style={
            item.isDuplicate.value == true
              ? { backgroundColor: `${item.isDuplicate.backgorundColor}` }
              : { backgroundColor: "" }
          }
        >
          <input
            className="numberFieldTest"
            placeholder={i18n.t("kickbackProject.fieldSumInput") ?? ""}
            style={{ width: "100%" ,appearance:'none'}}
            type="number"
            inputMode="numeric"
            onChange={(e) =>
              //this.props.onChangeContractUsers(item.uniqueRowId, e, key, item.index)
              this.onChangeDuplicates(e.target.value,key,item.uniqueRowId)
              
            }
            value={
              item.totalExclMoms.display
            }
          />
         {!item.totalExclMoms.valid  && (
            <FontAwesomeIcon
            className="exclamationIconStyle"
            style={{zIndex:100}}
              icon={faExclamation}
            />
          )}
        </div>
      );
    } else if (key == "invoiceNumber") {
      return (
        <div
          className={`fieldWrapper ${
            item.invoiceNumber.length == 0
              ? "fieldWrapper-error"
              : ''
             
          }`}
          style={
            item.isDuplicate.value == true
              ? { backgroundColor:`${item.isDuplicate.backgorundColor}`}
              : { backgroundColor: "" }
          }
        >
          <input
            placeholder={i18n.t('kickbackProject.fieldInvoiceNumberInput') ?? ''}
            style={{width:'100%'}}
            type="text"
            onChange={(e) =>
              this.onChangeDuplicates( e.target.value, key, item.uniqueRowId)
            }
            value={
             
              item.invoiceNumber
            }
          />
          {item.invoiceNumber.length == 0 && (
            <FontAwesomeIcon
            className="exclamationIconStyle"
              icon={faExclamation}
            />
          )}
        </div>
      );
    } else if (key == "billingDate") {
      return (
        <div
          className={`fieldWrapper ${
            item.billingDate.length > 0 ? "" : "fieldWrapper-error"
          }`}
          style={
            item.isDuplicate.value == true
              ? { backgroundColor: `${item.isDuplicate.backgorundColor}` }
              : { backgroundColor: "" }
          }
        >
          <input
            value={item.billingDate}
            min={_helpers.getMinOrMaxDateRange("min",this.props.period)}
            max={_helpers.getMinOrMaxDateRange("max",this.props.period)}
            onChange={(e) =>
              this.onChangeDuplicates(e.target.value,key,item.uniqueRowId)
            }
            required
            pattern="\d{4}-\d{2}-\d{2}"
            style={{
              cursor: "pointer",
              paddingRight: "30px",
            }}
            type="date"
          />

        </div>
      );
    }else if(key == 'contractId'){
    return(  <div
      className={`fieldWrapper ${
        item.contractId.length > 0 ? "" : "fieldWrapper-error"
      }`}
      style={
        item.isDuplicate.value == true
          ? {  backgroundColor: `${item.isDuplicate.backgorundColor}`,height:''}
          : { backgroundColor: "" ,height:''}
      }
    >
      {item.contractId.length == 0 ? (
        <>
        
          <Typeahead
            //allowNew
            positionFixed
            placeholder={i18n.t('kickbackProject.contractIdFieldValidation') ?? ''}
            newSelectionPrefix={i18n.t("kickbackProject.add")}
            emptyLabel={`${i18n.t("kickbackProject.emptyLabel")}`}
            id={`${item.uniqueRowId}`}
            options={Object.keys(this.props.contractDict)}
            onChange={(e) =>
             this.onChangeDuplicates(e,key,item.uniqueRowId) 
              
            }
          >{this.state.invoices.find(
            (x) => x.uniqueRowId == item.uniqueRowId
          )?.contractId ?? ""}
          </Typeahead>
          <FontAwesomeIcon
            style={{
              color: "#fff",
              fontSize: 20,
              right: 0,
              top: 20,
              paddingBottom: 0,
            }}
            icon={faExclamation}
          />
        </>
      ) : (
        <div
          title={`${i18n.t("kickbackProject.changeContractLabel")}`}
          style={{
            cursor: "pointer",
            height: "100%",
            alignItems: "center",
            display: "flex",
            padding: "0.3em",
            position: "relative",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width:'125px'
          }}
          onClick={(e) =>
            //this.handleRefOrCommentUpdate(item.uniqueRowId, key)
            this.onChangeDuplicates(e,key,item.uniqueRowId) 
          }
        >
          <span
            style={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            {" "}
            {item.contractId}-
            {this.props.contractDict[item.contractId].title}-
            {this.props.contractDict[item.contractId].name}
          </span>
        </div>
      )}
    </div>
    )
    } 
    else if(key == 'customerName' || key == 'customerOrgId'){
    return  <div
      className={`fieldWrapper ${
         item.customerOrgId.length > 0 ? '': "fieldWrapper-error"
      }`}
      style={
        item.isDuplicate.value == true
          ? {  backgroundColor: `${item.isDuplicate.backgorundColor}`,height:''}
          : { backgroundColor: "",height:'' }
      }
    >
      {item.customerName.length == 0 || item.customerOrgId.length == 0? (
        <>
        
          <Typeahead
            //allowNew
            positionFixed
            placeholder={i18n.t('kickbackProject.contractIdFieldValidation') ?? ''}
            newSelectionPrefix={i18n.t("kickbackProject.add")}
            emptyLabel={`${i18n.t("kickbackProject.emptyLabel")}`}
            id={`${item.uniqueRowId}`}
            options={key == 'customerName' ? Object.keys(this.props.customerDict): Object.values(this.props.customerDict).map((x:any) => x.customerOrgId)}
            onChange={(e) =>
             this.onChangeDuplicates(e,key,item.uniqueRowId) 
              
            }
          >{this.state.invoices.find(
            (x) => x.uniqueRowId == item.uniqueRowId
          )?.[key] ?? ""}
          </Typeahead>
          <FontAwesomeIcon
            style={{
              color: "#fff",
              fontSize: 20,
              right: 0,
              top: 20,
              paddingBottom: 0,
            }}
            icon={faExclamation}
          />
        </>
      ) : (
        <div
          title={key == 'customerName' ? `${i18n.t("kickbackProject.changeCustomer")}`: `${i18n.t("kickbackProject.changeCustomerOrgId")}`}
          style={{
            cursor: "pointer",
            height: "100%",
            alignItems: "center",
            display: "flex",
            padding: "0.3em",
            position: "relative",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
            width:'125px'
          }}
          onClick={(e) =>
            this.onChangeDuplicates(e,key,item.uniqueRowId) 
          }
        >
          {item[key]}
        </div>
      )}
    </div>
    }
    else {
      return (
        <div
          className="fieldWrapper"
          style={
            item.isDuplicate.value == true
              ? {
                  backgroundColor: `${item.isDuplicate.backgorundColor}`,
                  cursor: "pointer",
                  //height: "100%",
                  alignItems: "center",
                  display: "flex",
                  padding: "0.3em",
                  position: "relative",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  //width:'125px'
                }
              : {
                  backgroundColor: "",
                  cursor: "pointer",
                  height: "100%",
                  alignItems: "center",
                  display: "flex",
                  padding: "0.3em",
                  position: "relative",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  width: "125px",
                }
          }
        >
          {item[key]}
        </div>
      );
    }
  };
  private renderLoadingScreen = (): JSX.Element => {
    return (
      <div style={{ height: 200 }}>
        <div>{i18n.t('kickbackProject.verificationButton')}</div>
        <Spinner />
      </div>
    );
  };

  render() {
    const sendOrnotSend = this.state.invoices.filter(item => {
     
      return this.state.keyedInvoices[
        `${item.customerOrgId}${item.contractId}${item.tag}${item.billingDate}${item.totalExclMoms.value}`
      ] == "unique"
    })
  //  let groupedItems:ProjectInvoiceGrouped[] = []
  //   if(this.props.csrd){
  //   //   console.log(this.state.invoices,this.state.invoices)
  //   //  const dupps = this.state.report.filter(x => this.state.invoices.some((invoice) => {
  //   //    // Exclude the ignored key from both objects
  //   // const { ['isDuplicate']: _, ...filteredX } = x;
  //   // const { ['isDuplicate']: __, ...filteredInvoice } = invoice;

  //   // // Compare remaining properties
  //   // return JSON.stringify(filteredX) === JSON.stringify(filteredInvoice)
  //   //  }) )
  //  groupedItems =   this.state.invoices.reduce((prev, curr) => {
  //      const potentialGroup = prev.find(p => p.groupId == curr.groupId);
  //      if(potentialGroup){
  //        potentialGroup.items = potentialGroup.items.concat(curr);
  //      }
  //      else {
  //        prev = prev.concat({ 
  //          ...curr,
  //          items: [curr]
  //         })
  //      }
  //      return prev;
  //    }, [] as ProjectInvoiceGrouped[]);
  //  }
    return (
      <>
        {this.state.loading ? (
          <StyledModal
          headerStyle={{backgroundColor:'#173c53',color:'white'}}
            title={i18n.t('kickbackProject.modalTitle').toString()}
            body={<>{this.renderLoadingScreen()}</>}
            onDismiss={this.props.closeModal}
          />
        ) : (
          <StyledModal
          headerStyle={{backgroundColor:'#173c53',color:'white'}}
            className="full-width"
            onDismiss={this.props.closeModal}
            title={i18n.t('kickbackProject.manageDuplicates')?? ''}
            body={
              <>
                <div style={{ marginRight: 30 }}>
                  <div className="testTestTest" >
                    <ol>
                      <li
                        value={this.state.invoices.length}
                        style={{
                          accentColor: "rgb(11, 93, 151,0.8)",
                          borderLeft: "5px solid rgb(11, 93, 151,0.8)",
                          height:this.state.width < 500 ? 'fit-content' : ''
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            position: "inherit",
                            textAlign: "center",
                          }}
                        >
                          {/* <FontAwesomeIcon style={{color:'rgb(11, 93, 151,0.8)',fontSize:'48px'}} icon='copy'/> */}
                          <div
                            style={
                              this.state.width < 500
                                ? {
                                    display: "flex",
                                    flexDirection: "column",
                                    alignSelf: "center",
                                    
                                  }
                                : {}
                            }
                          >
                            <svg
                              fill="rgb(11, 93, 151,0.8)"
                              height="50px"
                              width="50px"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 492.838 492.838"
                              xmlSpace="preserve"
                            >
                              <path d="M28.772 39.031c6.738 0 12.221-5.482 12.221-12.22s-5.482-12.22-12.221-12.22-12.221 5.482-12.221 12.22 5.483 12.22 12.221 12.22zm0-15.94c2.052 0 3.721 1.669 3.721 3.72s-1.669 3.72-3.721 3.72-3.721-1.669-3.721-3.72 1.67-3.72 3.721-3.72zM59.567 39.031c6.738 0 12.221-5.482 12.221-12.22s-5.482-12.22-12.221-12.22c-6.738 0-12.221 5.482-12.221 12.22s5.483 12.22 12.221 12.22zm0-15.94c2.052 0 3.721 1.669 3.721 3.72s-1.669 3.72-3.721 3.72-3.721-1.669-3.721-3.72 1.67-3.72 3.721-3.72zM90.362 39.031c6.738 0 12.221-5.482 12.221-12.22s-5.483-12.22-12.221-12.22-12.221 5.482-12.221 12.22 5.483 12.22 12.221 12.22zm0-15.94c2.052 0 3.721 1.669 3.721 3.72s-1.669 3.72-3.721 3.72-3.721-1.669-3.721-3.72 1.67-3.72 3.721-3.72zM271.428 167.667H79.287a4.25 4.25 0 000 8.5h192.141a4.25 4.25 0 100-8.5z" />
                              <path d="M479.893 187.397H356.281V14.27c0-7.138-5.807-12.945-12.944-12.945H12.944C5.807 1.325 0 7.132 0 14.27v278.226c0 7.138 5.807 12.945 12.944 12.945h123.611v173.127c0 7.138 5.807 12.945 12.945 12.945h330.392c7.138 0 12.945-5.807 12.945-12.945V200.342c.001-7.138-5.807-12.945-12.944-12.945zM145.056 294.905h43.942a4.25 4.25 0 000-8.5h-43.942v-48.259h339.282v29.42h-63.232a4.25 4.25 0 100 8.5h63.232v183.273H145.056V294.905zm339.282-94.563v9.74H260.974a4.25 4.25 0 100 8.5h223.364v11.063H145.056v-29.304a4.45 4.45 0 014.445-4.445h330.392a4.452 4.452 0 014.445 4.446zm-334.837-12.945c-5.98 0-11.013 4.083-12.492 9.603H79.287a4.25 4.25 0 000 8.5h57.269v67.767H8.5V108.833h43.941a4.25 4.25 0 000-8.5H8.5V52.074h339.281v29.42H284.55a4.25 4.25 0 100 8.5h63.231v97.403h-198.28zM12.944 9.825h330.393a4.45 4.45 0 014.444 4.445v9.74H124.418a4.25 4.25 0 000 8.5h223.363v11.064H8.5V14.27a4.45 4.45 0 014.444-4.445zm0 287.116a4.45 4.45 0 01-4.444-4.445v-10.729h128.056v15.174H12.944zm466.949 186.072H149.501a4.45 4.45 0 01-4.445-4.445v-10.729h339.282v10.729a4.45 4.45 0 01-4.445 4.445z" />
                              <path d="M165.329 200.663c-6.738 0-12.221 5.482-12.221 12.22s5.482 12.22 12.221 12.22c6.738 0 12.22-5.482 12.22-12.22s-5.482-12.22-12.22-12.22zm0 15.94a3.725 3.725 0 01-3.721-3.72 3.725 3.725 0 013.721-3.72 3.724 3.724 0 013.72 3.72 3.724 3.724 0 01-3.72 3.72zM196.124 200.663c-6.738 0-12.221 5.482-12.221 12.22s5.482 12.22 12.221 12.22c6.738 0 12.22-5.482 12.22-12.22s-5.482-12.22-12.22-12.22zm0 15.94a3.725 3.725 0 01-3.721-3.72 3.725 3.725 0 013.721-3.72 3.724 3.724 0 013.72 3.72 3.724 3.724 0 01-3.72 3.72zM226.918 200.663c-6.738 0-12.22 5.482-12.22 12.22s5.482 12.22 12.22 12.22 12.221-5.482 12.221-12.22-5.483-12.22-12.221-12.22zm0 15.94a3.724 3.724 0 01-3.72-3.72 3.724 3.724 0 013.72-3.72 3.725 3.725 0 013.721 3.72 3.725 3.725 0 01-3.721 3.72zM139.973 148.981H269.69a4.25 4.25 0 004.25-4.25v-38.465a4.25 4.25 0 00-4.25-4.25H139.973a4.25 4.25 0 00-4.25 4.25v38.465a4.25 4.25 0 004.25 4.25zm4.25-38.465H265.44v29.965H144.223v-29.965zM117.544 148.981a4.25 4.25 0 004.25-4.25v-38.465a4.25 4.25 0 00-4.25-4.25H75.799a4.25 4.25 0 00-4.25 4.25v38.465a4.25 4.25 0 004.25 4.25h41.745zm-37.495-38.465h33.245v29.965H80.049v-29.965zM408.094 358.334H215.953a4.25 4.25 0 000 8.5h192.141a4.25 4.25 0 100-8.5zM408.094 387.667H215.953a4.25 4.25 0 000 8.5h192.141a4.25 4.25 0 100-8.5zM276.639 339.648h129.718a4.25 4.25 0 004.25-4.25v-38.465a4.25 4.25 0 00-4.25-4.25H276.639a4.25 4.25 0 00-4.25 4.25v38.465a4.25 4.25 0 004.25 4.25zm4.25-38.465h121.218v29.965H280.889v-29.965zM254.21 339.648a4.25 4.25 0 004.25-4.25v-38.465a4.25 4.25 0 00-4.25-4.25h-41.745a4.25 4.25 0 00-4.25 4.25v38.465a4.25 4.25 0 004.25 4.25h41.745zm-37.495-38.465h33.245v29.965h-33.245v-29.965z" />
                            </svg>

                            <svg
                              transform={
                                this.state.width < 500
                                  ? "rotate(90)"
                                  : undefined
                              }
                              fill="rgb(11, 93, 151,0.8)"
                              height={50}
                              width={50}
                              viewBox="-2.4 -2.4 28.80 28.80"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlSpace="preserve"
                            >
                              <path d="M3 13H1v-2h2zm4-2H5v2h2zm12 0h-2v2h2zm4 0h-2v2h2zm-12 0H9v2h2zm4 0h-2v2h2z" />
                              <path fill="none" d="M0 0h24v24H0z" />
                            </svg>

                            <svg
                              fill="rgb(11, 93, 151,0.8)"
                              height="50px"
                              width="50px"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 57 57"
                              xmlSpace="preserve"
                            >
                              <path d="M49.5 38c0-3.859-3.14-7-7-7s-7 3.141-7 7v1h-4v18h22V39h-4v-1zm-12 0c0-2.757 2.243-5 5-5s5 2.243 5 5v1h-10v-1zm14 3v14h-18V41h18z" />
                              <path d="M41.5 51.858V53a1 1 0 102 0v-1.142c1.72-.447 3-1.999 3-3.858 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 1.859 1.28 3.411 3 3.858zm1-5.858c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM53.354 8.51C52.197 4.22 43.578 0 28.5 0S4.803 4.22 3.646 8.51A.98.98 0 003.5 9v37c0 .161.042.313.115.448 1.139 4.833 10.691 7.68 19.811 8.364a.998.998 0 001.072-.922 1 1 0 00-.922-1.072c-11.115-.834-17.592-4.218-18.044-6.98a.963.963 0 00-.032-.131v-8.414l.057.048c.232.205.47.409.738.605C10.067 40.791 17.595 43 28.5 43a1 1 0 100-2c-.827 0-1.637-.016-2.432-.044-.482-.018-.947-.049-1.417-.076-.297-.017-.603-.028-.895-.049a58.617 58.617 0 01-1.829-.165c-.12-.013-.246-.021-.365-.034a56.105 56.105 0 01-2.005-.256l-.072-.009c-3.379-.499-6.279-1.26-8.548-2.165l-.051-.02a21.474 21.474 0 01-1.174-.514c-.047-.022-.097-.044-.144-.067-.333-.16-.64-.325-.935-.491-.073-.042-.15-.083-.221-.125-.256-.15-.49-.304-.714-.458-.089-.062-.18-.123-.263-.185a8.329 8.329 0 01-.786-.662 5.509 5.509 0 01-.583-.67 3.434 3.434 0 01-.373-.666 2.488 2.488 0 01-.114-.356c-.038-.163-.079-.326-.079-.488v-8.207l.057.048c.232.205.47.409.738.605C10.067 28.791 17.595 31 28.5 31c10.88 0 18.396-2.199 22.177-5.034.29-.212.55-.431.799-.653l.024-.021V34a1 1 0 102 0V9a.98.98 0 00-.146-.49zM51.5 13.293V21.5c0 .163-.041.327-.08.491a2.545 2.545 0 01-.26.66 3.667 3.667 0 01-.451.646 5.339 5.339 0 01-.625.627c-.16.139-.327.278-.513.415-.086.064-.18.127-.271.19-.222.153-.453.305-.706.453-.074.044-.153.087-.23.13a16.19 16.19 0 01-.926.487l-.153.071c-.369.174-.754.345-1.166.51l-.058.022c-2.269.904-5.166 1.665-8.543 2.164l-.074.01a56.28 56.28 0 01-2.003.256c-.12.013-.246.022-.367.034-.599.062-1.204.12-1.827.165-.293.021-.599.032-.897.049-.469.027-.934.059-1.416.076a69.222 69.222 0 01-4.866 0c-.482-.018-.947-.049-1.417-.076-.297-.017-.603-.028-.895-.049a58.617 58.617 0 01-1.829-.165c-.12-.013-.246-.021-.365-.034a56.105 56.105 0 01-2.005-.256l-.072-.009c-3.379-.499-6.279-1.26-8.548-2.165l-.051-.02a21.474 21.474 0 01-1.174-.514c-.047-.022-.097-.044-.144-.067-.333-.16-.64-.325-.935-.491-.073-.042-.15-.083-.221-.125-.256-.15-.49-.304-.714-.458-.089-.062-.18-.123-.263-.185a8.329 8.329 0 01-.786-.662 5.509 5.509 0 01-.583-.67 3.434 3.434 0 01-.373-.666 2.488 2.488 0 01-.114-.356c-.038-.163-.079-.326-.079-.488v-8.207c.12.109.257.216.387.324.072.06.139.12.215.18.3.236.624.469.975.696.073.047.155.093.231.14a17.11 17.11 0 001.299.731c.365.186.748.366 1.151.542.066.029.126.059.193.087.469.199.967.389 1.485.572.143.051.293.099.44.149.412.139.838.272 1.279.401.159.046.315.094.478.139.585.162 1.189.316 1.823.458.087.02.181.037.269.056a43.778 43.778 0 002.348.444c.567.093 1.151.179 1.75.257.154.02.301.042.457.062.744.09 1.514.167 2.305.233.195.016.398.028.596.042.633.046 1.28.084 1.942.114.241.011.481.022.727.03.862.029 1.74.05 2.65.05s1.788-.021 2.65-.05c.245-.008.485-.02.727-.03.662-.03 1.309-.068 1.942-.114.198-.015.4-.026.596-.042a60.436 60.436 0 002.305-.233c.156-.019.303-.042.457-.062a53.904 53.904 0 002.363-.361 43.778 43.778 0 001.735-.34c.088-.019.182-.036.269-.056a37.577 37.577 0 001.823-.458c.163-.045.319-.092.478-.139.441-.128.867-.262 1.279-.401.147-.05.297-.098.44-.149a27.194 27.194 0 001.485-.572c.067-.028.127-.059.193-.087a21.377 21.377 0 001.518-.735c.327-.175.638-.354.932-.538.076-.047.158-.093.231-.14.351-.227.675-.459.975-.696.075-.06.142-.12.215-.18.13-.108.267-.215.387-.324zM28.5 2c13.554 0 23 3.952 23 7.5s-9.446 7.5-23 7.5-23-3.952-23-7.5S14.946 2 28.5 2z" />
                            </svg>
                          </div>
                          <p
                            className="value"
                            style={{ color: "rgb(11, 93, 151,0.8)" }}
                          >
                            {this.state.invoices.length}
                          </p>
                          {/* <p className="textTitle">{i18n.t('kickbackProject.duplicates')} FUNNA I DATABASEN</p> */}
                          <p className="textTitle">
                            {i18n.t('kickbackProject.rowsAlreadyReported')}. </p>
                              <p className="textTitle">Dubbletterna har blivit färgmarkerade.</p>
                            <p className="textTitle">Återgå till föregående sida för att utföra ändringar.</p>
                        </div>
                      </li>
                    </ol>
                  </div>
                </div>
                <div /*className="verifyTable"*/ style={{ maxHeight: "100vh",minHeight:'10vh' ,overflow:'scroll'}}>
                 {!this.props.csrd &&
                 <EditableTable
                 onChange={() => console.log()}
                 columns={this.duplicateColumns}
                 data={this.state.invoices}
               /> 
                 } 
                  {/* <EditableTable
                columns={this.props.editableColumns}
                grouped={this.props.csrd ? {
                  groupedColumns: this.props.groupedColumns,
                  collapsedGroups: this.state.collapsedGroups,
                  onCollapseGroup: (groupId:number) => { 
                    const groupIdExists = this.state.collapsedGroups.includes(groupId);
                    const newList = groupIdExists ? 
                      this.state.collapsedGroups.filter(g => g != groupId)
                      :
                      this.state.collapsedGroups.concat(groupId);
                    this.setState({ collapsedGroups: newList });
                  },
                  onCollapseAll: () => {
                    const groupNumbers = this.state.invoices
                      .map(inv => inv.groupId)
                      .filter((grpId, i, self) => self.indexOf(grpId) == i);
                    if(groupNumbers.every(grpId => this.state.collapsedGroups.includes(grpId))){
                      this.setState({ collapsedGroups: [] });
                    }
                    else 
                      this.setState({ collapsedGroups: groupNumbers });
                  }
                }: undefined}
                data={
                  this.props.csrd ? groupedItems : this.state.invoices
                }
                onChange={
                  (newData) => console.log(newData) 
                }
             noItemsText={`${i18n.t('kickbackProject.noItems')}`}
              /> */}
                </div>
              </>
            }
            footer={
              <div>
              {!this.props.csrd &&  <Button
                  title={i18n.t('kickbackProject.confirmChangesButton') ?? ''}
                  onClick={this.verifyChanges}
                  className="verifyButton"
                  disabled={sendOrnotSend.length > 0} 
                >
                  <FontAwesomeIcon style={{marginRight:4}} icon='circle-check' size="lg"/>
                 {i18n.t('kickbackProject.confirmChangesButton') }
                </Button>
            }
              </div>
            }
          />
        )}
      </>
    );
  }
}
export default withTranslation()(KickbackReportDuplicatesModal);
